import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Constants } from 'src/app/constants/constants';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { ToastService } from 'src/app/service/toast.service';
import { UtilService } from 'src/app/service/util.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-device-history',
  templateUrl: './device-history.component.html',
  styleUrls: ['./device-history.component.scss']
})
export class DeviceHistoryComponent implements OnChanges {

  deviceDates: Array<any> = []
  // @Input() deviceData: any;
  @Input() deviceId: any;
  @Input() vin: any;
  deviceHistory: any;

  constructor(
    private apiService: ApiService,
    private toastService: ToastService,
    public utilService: UtilService,
    private authService: AuthenticationService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {

    // this.getDeviceHistory('6475b0cfa71f54d2280788dd', '3N1CN8EV1ML899472');
    this.getDeviceHistory(this.deviceId, this.vin);
  }

  /* initDeviceDates(statusHistory) {
    for (let i = 0; i < statusHistory.length; i++) {
      this.deviceDates.push(this.getDeviceHistoryObject(Constants.STATUS_NAME_MAP.get(statusHistory[i].status), statusHistory[i].date));
    }

  } */
  /* initDeviceDates(statusHistory) {
    if (statusHistory && statusHistory.length > 0) {
      for (let i = 0; i < statusHistory.length; i++) {
        this.deviceDates.push(this.getDeviceHistoryObject(Constants.STATUS_NAME_MAP.get(statusHistory[i].status), statusHistory[i].date));
      }
    } else {
      this.deviceDates = [];
    }

  } */
  initDeviceDates(statusHistory) {
    this.deviceDates = [];
    if (statusHistory && statusHistory.length > 0) {
      for (let i = 0; i < statusHistory.length; i++) {
        this.deviceDates.push(this.getDeviceHistoryObject(Constants.STATUS_NAME_MAP.get(statusHistory[i].status), statusHistory[i].date));
      }
    }

  }

  getDeviceHistoryObject(key: string, value: any) {
    var deviceHistory = { 'key': key, 'value': '' };
    if (!isNullOrUndefined(value)) {
      deviceHistory.value = value;
    }
    return deviceHistory;
  }

  getDeviceHistory(deviceId, deviceVin?) {
    this.utilService.showSpinner();
    this.apiService.getDeviceHistory(deviceId, deviceVin).then((data) => {
      this.utilService.hideSpinner();
      console.log("device history response::", data);
      this.deviceHistory = data;
      /* if (this.deviceHistory && this.deviceHistory.statusHistory) {
        this.initDeviceDates(this.deviceHistory.statusHistory);
      } */
      if (this.deviceHistory) {
        this.initDeviceDates(this.deviceHistory.statusHistory);
      } else {
        this.initDeviceDates(null);
      }      
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getDeviceHistory(deviceId, deviceVin);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onVehicleDeviceUnlink(data) {

    // this.getDeviceHistory('6475b0cfa71f54d2280788dd', '3N1CN8EV1ML899472');
    this.getDeviceHistory(this.deviceId);
  }

  updateDeviceHistory(data) {

    if (data.vin) {
      this.getDeviceHistory(this.deviceId, data.vin);
    }
  }

}
